import {OrderEmailScheduleModel } from "@TKCCP/Types/ApiModels";
import {ApiParameter,patch,get,del} from "@insite/client-framework/Services/ApiService";


export interface OrderReminderApiParameter extends ApiParameter {
    cartId : string;
    orderEmailScheduleModel: OrderEmailScheduleModel;
    orderNumber : string;
}
export interface UpdateOrderScheduleApiParameter extends ApiParameter {
    orderNumber: string;
    orderEmailScheduleModel: OrderEmailScheduleModel;
}
const orderReminderUrl = "/api/v1/OrderHistoryEmailSchedule";

export async function AddOrderReminder(parameter: OrderReminderApiParameter) {
    const orderEmailScheduleModel = parameter.orderEmailScheduleModel;
    const cartId = parameter.cartId;
    const model = await patch<OrderEmailScheduleModel>(`${orderReminderUrl}/${cartId}/true`, orderEmailScheduleModel);
    return model;
}
export function getOrderReminder(parameter: OrderReminderApiParameter): Promise<OrderEmailScheduleModel> {
    
    return get<OrderEmailScheduleModel>(`api/v1/OrderHistoryEmailSchedule/${parameter.orderNumber}`);
}

export function updateOrderSchedule(parameter: UpdateOrderScheduleApiParameter) {
     return patch<OrderEmailScheduleModel>(`${orderReminderUrl}/${parameter.orderNumber}/false`, parameter.orderEmailScheduleModel);

}

